class ShowSwiperImage extends HTMLElement {
  constructor() {
    super();
    this.productInfo = this.closest('product-info');
    this.thumbnails = [...this.productInfo.querySelectorAll('.product-gallery .product-single__thumbnails .product-single__thumbnail')];
    this.image = this.querySelector('img');
    this.imageURL = this.image.src.split('?')[0];
  }

  connectedCallback() {
    this.image.addEventListener('click', this.handleClick);
    this.image.style.cursor = 'pointer';
    this.hiResURL = this.imageURL + '?width=600';
    this.thumbSrc = this.image.currentSrc || this.image.src;

    if (window.innerWidth < 990) {
      ShowSwiperImage.queuePreload(this);
    }
  }

  static preloadQueue = [];
  static preloadObserver = null;
  static preloadCache = {};
  static queuePreload(instance) {
    if (!ShowSwiperImage.preloadObserver) {
      ShowSwiperImage.preloadObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            ShowSwiperImage.preloadObserver.unobserve(entry.target);
            ShowSwiperImage.preloadAll();
          }
        });
      }, { rootMargin: '300px' });
    }
    ShowSwiperImage.preloadQueue.push(instance);
    ShowSwiperImage.preloadObserver.observe(instance);
  }

  static preloadAll() {
    ShowSwiperImage.preloadQueue.forEach(function(inst) {
      if (ShowSwiperImage.preloadCache[inst.hiResURL]) return;
      var img = new Image();
      img.src = inst.hiResURL;
      ShowSwiperImage.preloadCache[inst.hiResURL] = img;
    });
    ShowSwiperImage.preloadQueue = [];
  }

  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (window.innerWidth < 990) {
      this.showMobilePreview();
    } else {
      this.showFlickityImage();
    }
  }

  showFlickityImage() {
    const slider = this.productInfo.querySelector('[data-product-single-media-slider]');
    const flkty = window.theme.Flickity.data(slider) ?? null;
    if (!flkty || !flkty.isActive) return;

    const mediaElements = [...slider.querySelectorAll('[data-media-id]')];
    const targetIndex = mediaElements.findIndex(el => {
      const img = el.querySelector('img');
      if (!img) return false;
      const url = img.src.split('?')[0];
      return url === this.imageURL || this.imageURL.includes(url);
    });

    if (targetIndex > -1) flkty.select(targetIndex);
  }

  showMobilePreview() {
    if (document.querySelector('.bundle-preview-overlay')) return;

    ShowSwiperImage.injectStyles();

    const variantColor = this.dataset.variantColor || '';
    const hiResURL = this.hiResURL;
    const thumbSrc = this.thumbSrc;
    const cached = ShowSwiperImage.preloadCache[hiResURL];
    var initialSrc = (cached && cached.complete) ? hiResURL : thumbSrc;

    const overlay = document.createElement('div');
    overlay.className = 'bundle-preview-overlay';
    overlay.innerHTML =
      '<div class="bundle-preview-backdrop"></div>' +
      '<div class="bundle-preview-content">' +
        '<button class="bundle-preview-close" type="button" aria-label="Close preview">\u00D7</button>' +
        '<div class="bundle-preview-image-wrap">' +
          '<img src="' + initialSrc + '" alt="' + variantColor + '" class="bundle-preview-img" />' +
        '</div>' +
        (variantColor ? '<p class="bundle-preview-label">' + variantColor + '</p>' : '') +
      '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('is-visible'); });

    if (initialSrc !== hiResURL) {
      var previewImg = overlay.querySelector('.bundle-preview-img');
      var swap = new Image();
      swap.onload = function() { previewImg.src = hiResURL; };
      swap.src = hiResURL;
    }

    var close = function() {
      overlay.classList.remove('is-visible');
      overlay.addEventListener('transitionend', function() { overlay.remove(); }, { once: true });
      setTimeout(function() { overlay.remove(); }, 350);
    };

    overlay.querySelector('.bundle-preview-backdrop').addEventListener('click', close);
    overlay.querySelector('.bundle-preview-close').addEventListener('click', close);
    overlay.addEventListener('touchstart', function(e) {
      if (e.target.classList.contains('bundle-preview-backdrop')) close();
    }, { passive: true });
  }

  static stylesInjected = false;
  static injectStyles() {
    if (ShowSwiperImage.stylesInjected) return;
    ShowSwiperImage.stylesInjected = true;
    var s = document.createElement('style');
    s.textContent =
      '.bundle-preview-overlay{' +
        'position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;' +
        'display:flex;align-items:center;justify-content:center;' +
        'opacity:0;transition:opacity .25s ease;pointer-events:none;' +
      '}' +
      '.bundle-preview-overlay.is-visible{opacity:1;pointer-events:auto;}' +
      '.bundle-preview-backdrop{' +
        'position:absolute;top:0;left:0;right:0;bottom:0;' +
        'background:rgba(0,0,0,0.55);' +
      '}' +
      '.bundle-preview-content{' +
        'position:relative;width:85vw;max-width:380px;' +
        'background:var(--color-beige-200,#f0eae2);' +
        'border-radius:var(--border-16,12px);overflow:hidden;' +
        'transform:scale(.92);transition:transform .25s ease;' +
      '}' +
      '.bundle-preview-overlay.is-visible .bundle-preview-content{transform:scale(1);}' +
      '.bundle-preview-close{' +
        'position:absolute;top:8px;right:8px;z-index:2;' +
        'width:32px;height:32px;border-radius:50%;border:none;' +
        'background:rgba(255,255,255,0.85);color:var(--color-teal-400,#007a7a);' +
        'font-size:20px;line-height:1;cursor:pointer;' +
        'display:flex;align-items:center;justify-content:center;' +
      '}' +
      '.bundle-preview-image-wrap{' +
        'width:100%;aspect-ratio:1/1;overflow:hidden;' +
        'background:var(--color-beige-300,#e5ddd3);' +
      '}' +
      '.bundle-preview-img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.bundle-preview-label{' +
        'margin:0;padding:14px 16px;text-align:center;' +
        'font-family:var(--font-outfit,sans-serif);' +
        'font-size:16px;font-weight:500;' +
        'color:var(--color-teal-400,#007a7a);' +
      '}';
    document.head.appendChild(s);
  }
}

if (!customElements.get('show-swiper-image')) {
  customElements.define('show-swiper-image', ShowSwiperImage);
}